export default "__VITE_ASSET__B4b6BtnB__"